import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import EuroIcon from "@mui/icons-material/Euro";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import { Typography } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    fontSize: "1.8rem",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "1.8rem",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function PriceTable({ priceList }) {
  return (
    <>
      <ListItem sx={{ pb: 4, pt: 2 }}>
        <ListItemAvatar>
          <Avatar>
            <EuroIcon />
          </Avatar>
        </ListItemAvatar>
        <Typography component="div" sx={{ fontSize: "2rem", fontWeight: 500 }}>
          Cenník
        </Typography>
      </ListItem>
      <TableContainer
        component={Paper}
        sx={{ boxSizing: "border-box", maxWidth: "calc(96%)", ml: '2%' }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Služba</StyledTableCell>
              <StyledTableCell align="right">Cena</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {priceList.map((row) => (
              <StyledTableRow key={row.service}>
                <StyledTableCell component="th" scope="row">
                  {row.service}
                </StyledTableCell>
                <StyledTableCell align="right">{row.price}€</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default PriceTable;
